import ajax from '../lib/ajax.js'
//注册
export function registers(params) {
    return ajax({
        url: '/index.php/Home/Login/register',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//登录
export function logins(params) {
    return ajax({
        url: '/index.php/Home/Login/login',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//发布
export function upLoad(params) {
    return ajax({
        url: '/index.php/Home/File/upLoad',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//首页列表
export function productList(params) {
    return ajax({
        url: '/index.php/Home/File/productList',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//详情
export function productDetail(params) {
    return ajax({
        url: '/index.php/Home/File/productDetail',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//手机列表
export function productAllList(params) {
    return ajax({
        url: '/index.php/Home/File/productAllList',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//电脑发布
export function Computer_upLoad(params) {
    return ajax({
        url: '/index.php/Home/Computer/upLoad',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//电脑详情
export function Computer_productDetail(params) {
    return ajax({
        url: '/index.php/Home/Computer/productDetail',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//电脑列表
export function Computer_productAllList(params) {
    return ajax({
        url: '/index.php/Home/Computer/productAllList',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//手机列表删除
export function productDelete(params) {
    return ajax({
        url: '/index.php/Home/File/productDelete',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}
//电脑列表删除
export function Computer_productDelete(params) {
    return ajax({
        url: '/index.php/Home/Computer/productDelete',
        method: 'post',
        data: params
    }).then(res => {
        return Promise.resolve(res)
    })
}


// WEBPACK FOOTER //
// ./src/lib/api.js